import "./style.css";
import { getInstance } from "@app";
import layout from "./layout.html";

export default class ContactsMap {
  static selector = ".contacts__map";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
